import PouchDB from 'pouchdb';

import { upsert } from './common';

const CURRENT_ORDER_KEY = 'XXSFCurrentOrderKey';

class CurrentOrderStore {
  constructor(name) {
    this.db = new PouchDB(name);
  }

  upsert = (key, data, onUpsert) => upsert(this.db, key, data, onUpsert);

  setCurrentOrder = (orderId, onSuccess) => {
    this.upsert(
      CURRENT_ORDER_KEY,
      {
        _id: CURRENT_ORDER_KEY,
        orderId,
      },
      onSuccess,
    );
  };

  getCurrentOrder = (callback) => {
    this.db
      .get(CURRENT_ORDER_KEY)
      .then((doc) => {
        callback(doc);
      })
      .then(() => {})
      .catch(() => {
        callback();
      });
  };
}

export default CurrentOrderStore;
